import ProductSellersLayout from "../../layout/ProductSellersLayout/ProductSellersLayout";
import ViewSellerLayout from "../../layout/ProductSellersLayout/SubLayouts/ViewSellerLayout/ViewSellerLayout";
import ActiveSellerList from "../../pages/LADProductSellers/ActiveSellerList/ActiveSellerList";
import AddSeller from "../../pages/LADProductSellers/AddSeller/AddSeller";
import Trash from "../../pages/LADProductSellers/Seller Trash/Trash";
import SellerSettings from "../../pages/LADProductSellers/SellerSettings/SellerSettings";
import ViewSellerDetails from "../../pages/LADProductSellers/ViewBuyer/Buyer Details/ViewSellerDetails";
import PurchasedLeads from "../../pages/LADProductSellers/ViewBuyer/PurchasedLeads/PurchasedLeads";
import SubscriptionPlan from "../../pages/LADProductSellers/ViewBuyer/SubscriptionPlan/SubscriptionPlan";
import PurchaseHistory  from "../../pages/LADProductSellers/ViewBuyer/PurchaseHistory/PurchaseHistory";
import ReviewAndRatings from "../../pages/LADProductSellers/ViewBuyer/ReviewAndRatings/ReviewAndRatings";
import RFQsQuotes from "../../pages/LADProductSellers/ViewBuyer/RFQsQuotes/RFQsQuotes";
import CommunicationHistory from "../../pages/LADProductSellers/ViewBuyer/CommunicationHistory/CommunicationHistory";
import UpdateSeller from "../../pages/LADProductSellers/updateSeller/UpdateSeller";
import UpdateSellerLayOut from "../../layout/ProductSellersLayout/SubLayouts/ViewSellerLayout/UpdateSellerLayOut";

const ProductSellerRoutes = [
  {
    path: "productsellers",
    element: <ProductSellersLayout />,
    children: [
      {
        index: true,
        element: <ActiveSellerList />,
      },
      {
        path: "all-seller",
        element: <ActiveSellerList />,
      },
      {
        path: "add-seller",
        element: <AddSeller />,
         children: [
          {
            path: "view-seller",
            element: <ViewSellerLayout/>,
          },
        ],
      },
      {
        path: "seller-settings",
        element: <SellerSettings />,
      },
      {
        path: "seller-trash",
        element: <Trash/>,
      },
    ],
  },
  {
      path: "update-seller",
      element: <UpdateSellerLayOut/>,
      children: [
        {
          index: true,
          element: <UpdateSeller />,
        },
        {
          path: "update-buyer",
          element: <UpdateSeller />,
        },
      ],
    },
  {
    path: "view-seller/",
    element: <ViewSellerLayout />,
    children: [
      {
        index: true,
        element: <ViewSellerDetails />,
      },
      {
        path: "seller-details/",
        element: <ViewSellerDetails />,
      },
      {
        path: "purschase",
        element: <PurchasedLeads />,
      },
      {
        path: "subscriptionplan",
        element: <SubscriptionPlan />,
      },
      {
        path: "purschasehistories",
        element: <PurchaseHistory />,
      },
      {
        path: "reviewratings",
        element: <ReviewAndRatings />,
      },
      {
        path: "rfqs",
        element: <RFQsQuotes />,
      },
      {
        path: "commmunication",
        element: <CommunicationHistory />,
      },
    ],
  },
];
export default ProductSellerRoutes;
